module.exports = __webpack_public_path__ + "static/media/speech_27.d50e8069.svg";